import React from "react";
import HeroSectionVideo from './HeroSectionVideo'
import HeroCarruselImg from './HeroCarruselImg'
import HeroSectionPlus from "../../HeroSectionPlus/HeroSectionPlus";


const HeroSection = ({ hero_section }) => {


    const media = hero_section.media;
    const type_media = hero_section.type;




    const { type, url, title, subtitle } = media;

    if (type_media === "image") {
        const slides = media.map((item) => ({
            image: item.url,
            title: item.title ?? "",
            subtitle: item.subtitle ?? "",
        }));
        return <>

            <HeroCarruselImg slides={slides} /> 
             {/* <HeroSectionPlus slides_img={slides} /> */}
        </>
    }


    if (type_media === "video") {

        console.log("Contenido de video ", media[0].url)
        return <HeroSectionVideo video_bg={media[0].url} />;
    }

    return <></>; // fallback si llega algo inesperado
};

export default HeroSection;